import CustomerContext from "../Context/CustomerContext";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { GetInvoiceData } from "../store/invoiceAtom";
import { Grid } from "@mui/material";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import ActionPaneComponent from "../helpers/ActionPaneComponent";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import StatusBadge from "../generals/StatusBadge";

function InvoiceScroll(props) {
  const getInvoiceData = GetInvoiceData();

  const [tableData, setTableData] = useState([]);
  const { invoice_id } = useParams();

  useEffect(() => {
    setTableData( getInvoiceData?.invoice_info?.map((ele) => {
        return { ...ele, checked: false };
      })
    );
  }, [getInvoiceData]);

  const onSelectBulkAction = (action) => {
    const option = action.target.value;
    if (option === "") {
      return setTableData(
        getInvoiceData?.invoice_info?.map((ele) => {
          return { ...ele, checked: false };
        })
      );
    }
    var newList = getInvoiceData?.invoice_info.filter(
      (item) => item.Invoice_Status_Id == option
    );
    setTableData(
      newList?.map((ele) => {
        return { ...ele, checked: false };
      })
    );
  };

  const onCheckAll = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData((prev) => {
      return [...tableData];
    });
    props?.onSelection(tableData);
  };

  return (
    <>
      <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[1000px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px]">
        <div className="border-b-[1px] border-b-gray-300">
          <ActionPaneComponent
            bulkActionData={getInvoiceData?.filtering_criteria}
            onSelectBulkAction={onSelectBulkAction}
          />
        </div>
        {tableData.map((invoice, i) => {
          return (
            <div  
              className={`p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200 ${
                invoice_id == invoice?.Invoice_Ref_No
                  ? "bg-gray-200"
                  : "hover:bg-gray-100"
              }`}
            >
              <div className="flex flex-row">
                <div className="">
                  <input
                    onChange={(e) => onCheckAll(e, i)}
                    checked={invoice?.checked ? invoice?.checked : ""}
                    type="checkbox"
                    className="w-4 h-4 border-[1px] border-gray-300 rounded-sm cursor-pointer"
                  />
                </div>

                <div
                  onClick={() => props.viewItemDetails(invoice.Invoice_Ref_No)}
                  className="ml-1"
                >
                  <div className="text-sm font-bold text-gray-700">
                    {invoice?.Customer_First_Name}
                  </div>
                  <div className="text-xs text-gray-400 font-semibold italic">
                    {invoice?.Invoice_Ref_No}
                  </div>
                  <div className="text-sm lg:text-xs text-gray-600">
                    {moment(invoice?.Invoice_Date).format("DD-MM-YYYY")}
                  </div>
                </div>
              </div>
              <div
                onClick={() => props.viewItemDetails(invoice.Invoice_Ref_No)}
                className="lg:mt-2 lg:ml-5 "
              >
                <div className={twMerge("text-sm font-normal")}>
                  <StatusBadge
                    statusId={invoice?.Invoice_Status_Id}
                    statusName={invoice?.Invoice_Status_Name}
                  />
                </div>

                <div className="mt-[2px] text-sm lg:text-xs font-bold text-gray-700">
                  <CurrencyFormat
                    value={parseFloat(invoice?.Invoice_Amount)?.toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"₦"}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </section>
    </>
  );
}

export default InvoiceScroll;
